import React, { createContext, useContext, useEffect, useState } from "react";
import { onAuthChange, getUserProfile } from "../services/authService";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthChange(async (firebaseUser) => {
      if (firebaseUser) {
        setUser(firebaseUser);
        const p = await getUserProfile(firebaseUser.uid);
        setProfile(p);
      } else {
        // Check for guest session
        const guest = sessionStorage.getItem("tapped_guest");
        if (guest) {
          const guestData = JSON.parse(guest);
          setUser(guestData);
          setProfile(guestData);
        } else {
          setUser(null);
          setProfile(null);
        }
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const refreshProfile = async () => {
    if (user && !user.isGuest) {
      const p = await getUserProfile(user.uid);
      setProfile(p);
    }
  };

  const setGuestUser = (guestData) => {
    sessionStorage.setItem("tapped_guest", JSON.stringify(guestData));
    setUser(guestData);
    setProfile(guestData);
  };

  const clearGuestUser = () => {
    sessionStorage.removeItem("tapped_guest");
    setUser(null);
    setProfile(null);
  };

  return (
    <AuthContext.Provider value={{
      user,
      profile,
      loading,
      refreshProfile,
      setGuestUser,
      clearGuestUser,
      isGuest: user?.isGuest || false,
      isLoggedIn: !!user,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within AuthProvider");
  return context;
}
